// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1hUAN","background":"card-module--background--2ZkxR","content":"card-module--content--3ByKD","title":"card-module--title--JrmTG"};